import type { ClientIP } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { X } from "lucide-react";

interface ClientIpFilterProps {
  value: ClientIP;
  onChange: (value: ClientIP) => void;
}

export function ClientIpFilter({ value, onChange }: ClientIpFilterProps) {
  const addBlock = () => onChange({ ...value, blocks: [...value.blocks, ""] });
  const updateBlock = (i: number, v: string) => {
    const next = [...value.blocks];
    next[i] = v;
    onChange({ ...value, blocks: next });
  };
  const removeBlock = (i: number) =>
    onChange({ ...value, blocks: value.blocks.filter((_, j) => j !== i) });

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-xs">IP Blocks</Label>
        <Button type="button" variant="outline" size="sm" onClick={addBlock}>
          Add Block
        </Button>
      </div>
      {value.blocks.map((block, i) => (
        <div key={i} className="flex items-center gap-2">
          <Input
            value={block}
            onChange={(e) => updateBlock(i, e.target.value)}
            placeholder="cidr block"
            className="flex-1"
          />
          <Button type="button" variant="ghost" size="icon" onClick={() => removeBlock(i)}>
            <X className="h-4 w-4 text-red" />
          </Button>
        </div>
      ))}
    </div>
  );
}
